import React from 'react';
import { Link } from 'react-router-dom';
import '../../CSS/Blog.css';
import '../../CSS/App.css';

const UbuntuLabBlog = () => {
  return (
    <div className="blog-container">
      <Link to="/blog" className="blog-back-link">← Back to Blog</Link>

      <p className="blog-post-title">Ubuntu Home Lab</p>
      <p className="blog-meta">Ubuntu Server · Linux · Networking · Self-Hosted</p>

      <div className="blog-body">
        <p>
          This whole thing started because I had an old ThinkPad sitting around that I basically never used. I
          didn't really know what I wanted to do with it, but letting a perfectly usable computer sit in a
          drawer felt like a waste.
        </p>
        <p>
          So I wiped Windows off of it, installed Ubuntu Server, and decided to turn it into a home server.
        </p>
        <p>
          I didn't really realize at the time how much I would end up learning from it.
        </p>

        <h2>Starting Out</h2>
        <p>
          Installing Ubuntu Server itself was pretty straightforward. Everything after that was where I
          actually had to learn.
        </p>
        <p>
          There wasn't a GUI I could fall back on, so I had to get comfortable doing everything through the
          terminal. I learned how to SSH into it, manage services with systemctl, look through logs when
          something broke, and actually pay attention to what was running on the machine.
        </p>
        <p>
          I remember setting up SSH key authentication so I could connect from my main computer without typing
          my password every time. It's a pretty basic thing looking back, but at the time getting it working
          felt really cool.
        </p>

        <h2>What It Became</h2>
        <p>
          Over time I just kept adding stuff to it.
        </p>
        <p>
          Now I use it for websites, file storage, Docker containers, and whatever random thing I want to
          experiment with. It's basically become the computer where I'm allowed to break things.
        </p>
        <p>
          And I break things pretty often.
        </p>
        <p>
          That's probably the most useful part of having it. If I mess something up, I can't just give up
          because some of the stuff I actually use is running on there. I have to look through logs, search
          around, understand what happened, and fix it.
        </p>
        <p>
          I genuinely think I've learned more about Linux from messing with that server than I did from
          classes.
        </p>

        <h2>The Part I Didn't Expect</h2>
        <p>
          The biggest surprise was probably how much networking I ended up learning.
        </p>
        <p>
          I didn't build the server because I wanted to study networking. I just wanted a server. But then I
          wanted to access something from another computer, which meant learning about ports. Then I wanted to
          access it outside my house, which meant port forwarding. Then I wanted a domain, which meant DNS.
          Then I wanted HTTPS, reverse proxies, and everything else that came along with it.
        </p>
        <p>
          It kind of turned into its own class without me realizing it.
        </p>
        <p>
          That's probably what I like most about the home lab. I start with something I want to make work, run
          into something I don't understand, learn enough to fix it, and then eventually run into the next
          thing.
        </p>
      </div>
    </div>
  );
};

export default UbuntuLabBlog;
